import type {ReactNode} from "react";

export type DsSectionHeaderProps = {
  title: string;
  actionLabel?: string;
  actionHref?: string;
  onActionClick?: () => void;
  children?: ReactNode;
};

export function DsSectionHeader({title, actionLabel, actionHref, onActionClick, children}: DsSectionHeaderProps) {
  return (
    <div className="cc-ds-sectionHeader">
      <h2 className="cc-ds-sectionHeader__title">{title}</h2>
      {children}
      {actionLabel && actionHref ? (
        <a href={actionHref} className="cc-ds-sectionHeader__link">{actionLabel}</a>
      ) : null}
      {actionLabel && !actionHref && onActionClick ? (
        <button type="button" className="cc-ds-sectionHeader__link" onClick={onActionClick} style={{background: "none", border: 0, cursor: "pointer", padding: 0}}>
          {actionLabel}
        </button>
      ) : null}
    </div>
  );
}
